import { v4 as uuid } from 'uuid'

const defaultItem = {
    // id: string,
    // title: 'string',
    text: '',
    buttons: [
        {
            title: '확인',
            type: 'primary',
            value: true,
        }
    ],
}

export const dialog = {
    state: {
        que: [],
    },

    mutations: {
        'DIALOG/ADD'(state, payload) {
            state.que.push(payload)
        },
        'DIALOG/REMOVE'(state, id) {
            state.que = state.que.filter(item => item.id !== id)
        },
    },

    actions: {
        addDialog({ commit }, payload) {
            commit('DIALOG/ADD', {
                ...defaultItem,
                ...payload,
                id: payload.id || uuid(),
            })
        },
        removeDialog({ commit }, id) {
            commit('DIALOG/REMOVE', id);
        },
    },

    getters: {
        dialogs: (state) => state.que,
        latestDialog: (state) => state.que.length ? state.que[state.que.length - 1] : undefined,
    },
};

export default dialog;
